export default [
  {
    path: '/search',
    name: 'indexSearch',
    meta: { title: 'indexSearch' },
    component: () => import('@/pages/search'),
  },
]
